export default "/_next/static/images/signin-2-480708ec4c4b13dcdc7ca5b378e58c68.png";